// extracted by mini-css-extract-plugin
export var growableInput = "_37-0";
export var tagContainer = "_37-2";
export var textInput = "_37-1";